import * as React from "react";

import "./Nav.css";

import { Page } from "../Page";
import { PageLink } from "./PageLink";

interface IProps {
  currentPage: Page;
  onClick: (selected: Page) => void;
}
export class Nav extends React.Component<IProps> {
  public render() {
    const { currentPage, onClick } = this.props;
    return (
      <nav className="topnav">
        <PageLink
          page="user_list"
          currentPage={currentPage}
          onClick={onClick}
        />
        <div className="topnav-item">
          <a
            className="topnav-link"
            target="_blank"
            href="https://metabase.i.dialup.com/question/58?limit=100"
          >
            Calls
          </a>
        </div>
        <PageLink page="topics" currentPage={currentPage} onClick={onClick} />
        <PageLink page="lines" currentPage={currentPage} onClick={onClick} />
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.tsx